import { Box } from "@mui/material";
import { useRef } from "react";
import { CSSProperties } from "styled-components";
import { useDrag } from "./use-drag";

interface DraggableComponentProps extends CSSProperties {
  children: React.ReactNode;
  initialPosition?: { x: number; y: number };
  isFullScreen?: boolean;
}

/**
 * @description To Manage the draggable component for TeleHealth
 *
 * @author Rajkumar Rathod
 *
 */
const DraggableContainer: React.FC<DraggableComponentProps> = ({
  children,
  initialPosition,
  isFullScreen,
  ...others
}) => {
  const dialogRef = useRef<HTMLDivElement>(null);
  const { position, handleMouseDown } = useDrag({
    ref: dialogRef,
    initialPosition,
  });

  const MINIMiZE_STYLE: CSSProperties = {
    position: "absolute",
    left: position.x,
    top: position.y,
    cursor: "move",
    minWidth: others?.width ? others?.width : 480,
    // padding: "4px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    borderRadius: "8px",
    zIndex: others?.zIndex ?? 990,
  };

  const MAXIMIZE_STYLE: CSSProperties = {
    position: "fixed",
    top: 0,
    left: 0,
    height: "100svh",
    width: "100svw",
    padding: "10px",
    zIndex: others?.zIndex ?? 990,
  };

  return (
    <Box
      width={isFullScreen ? "100%" : others?.width}
      height={isFullScreen ? "100%" : others?.height}
      bgcolor={others?.backgroundColor ? others?.backgroundColor : "white"}
      color={others?.color ? others?.color : "black"}
      style={!isFullScreen ? MINIMiZE_STYLE : MAXIMIZE_STYLE}
      ref={dialogRef}
      onMouseDown={(e) => {
        const targetElement = e.target as HTMLElement;
        if (targetElement.tagName !== "TEXTAREA") {
          handleMouseDown(e);
        }
      }}
    >
      {children}
    </Box>
  );
};

export default DraggableContainer;
